var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { Bar } from "vue-chartjs";
import { Vue, Component, Prop, Watch } from "vue-facing-decorator";
import "chartjs-plugin-annotation";
import "chart.js";
import { _adapters } from 'chart.js';
import { DateHelper } from "@/app/utils/date-helper";
import { Chart as ChartJS, PointElement, BarElement, Title, Tooltip, Legend, LinearScale } from 'chart.js';
import annotationPlugin from 'chartjs-plugin-annotation';
ChartJS.register(LinearScale, PointElement, BarElement, Title, Tooltip, Legend, annotationPlugin);
_adapters._date.override(DateHelper.getChartJSDateAdapter());
let SnapshotGraph = class SnapshotGraph extends Vue {
    constructor() {
        super(...arguments);
        this.showLegend = false;
        this.displayLimits = false;
        this.canPlot = false;
        this.prevSuggestedMax = null;
        this.prevSuggestedMin = null;
        this.showLimits = false;
        this.containerWidth = 0;
    }
    mounted() {
        this.showLimits = this.displayLimits;
        window.addEventListener('resize', this.updateContainerWidth);
        this.plot();
    }
    ;
    beforeUnmount() {
        window.removeEventListener('resize', this.updateContainerWidth);
    }
    ;
    onShowLimitsChanged(newValue, oldValue) {
        if (newValue !== oldValue) {
            this.plot();
            this.$emit("displayLimitsChanged", this.showLimits);
        }
    }
    ;
    plot() {
        var _a, _b, _c, _d, _e;
        if (!this.chartData)
            return;
        this.renderOptions = Object.assign({}, this.options);
        if (this.showLimits) {
            try {
                if (((_b = (_a = this.renderOptions) === null || _a === void 0 ? void 0 : _a.scales) === null || _b === void 0 ? void 0 : _b.y) && (this.prevSuggestedMin !== null && this.prevSuggestedMax !== null)) {
                    this.renderOptions.scales.y.suggestedMax = this.prevSuggestedMax;
                    this.renderOptions.scales.y.suggestedMin = this.prevSuggestedMin;
                }
                if (this.chartData.annotations) {
                    this.renderOptions.plugins.annotation = {
                        annotations: JSON.parse(JSON.stringify(this.chartData.annotations))
                    };
                }
                this.renderOptions.plugins.annotation.annotations.forEach((item) => {
                    item.xScaleID = 'xLimit';
                    item.yScaleID = 'y';
                });
            }
            catch (ex) {
                console.error(ex);
            }
        }
        else {
            this.renderOptions.plugins.annotation = {};
            if ((_d = (_c = this.renderOptions) === null || _c === void 0 ? void 0 : _c.scales) === null || _d === void 0 ? void 0 : _d.y) {
                this.prevSuggestedMax = this.renderOptions.scales.y.suggestedMax;
                this.prevSuggestedMin = this.renderOptions.scales.y.suggestedMin;
                let min = null;
                let max = null;
                var data = this.chartData;
                (_e = data.datasets) === null || _e === void 0 ? void 0 : _e.forEach(dataset => {
                    var _a;
                    (_a = dataset.data) === null || _a === void 0 ? void 0 : _a.forEach(value => {
                        if (min == null || value < min)
                            min = value;
                        if (max == null || value > max)
                            max = value;
                    });
                });
                if (min != null && max != null) {
                    let range = max - min;
                    if (range === 0) {
                        // When all values are the same, add a fixed margin
                        let topMargin = Math.abs(max) * 0.02 || 1;
                        let bottomMargin = Math.abs(min) * 0.1 || 1;
                        let calculatedMin = min - bottomMargin;
                        this.renderOptions.scales.y.suggestedMin = min >= 0 && calculatedMin < 0 ? 0 : Number(calculatedMin.toFixed(2));
                        this.renderOptions.scales.y.suggestedMax = Number((max + topMargin).toFixed(2));
                    }
                    else {
                        this.renderOptions.scales.y.suggestedMin = Number((min - (range * 0.05)).toFixed(2));
                        this.renderOptions.scales.y.suggestedMax = Number((max + (range * 0.05)).toFixed(2));
                    }
                }
            }
        }
        this.renderData = JSON.parse(JSON.stringify(this.chartData));
        this.renderData.datasets.forEach((dataset) => {
            dataset.xAxisID = dataset.xAxisID || undefined;
            dataset.yAxisID = dataset.yAxisID || undefined;
        });
        this.canPlot = this.renderData.datasets && this.renderData.datasets.length > 0;
        this.updateContainerWidth();
    }
    ;
    updateContainerWidth() {
        const parent = this.$refs.containerDiv;
        if (parent && parent.parentElement) {
            this.containerWidth = parent.parentElement.offsetWidth;
        }
    }
};
__decorate([
    Prop(),
    __metadata("design:type", typeof (_a = typeof ChartObject !== "undefined" && ChartObject) === "function" ? _a : Object)
], SnapshotGraph.prototype, "chartData", void 0);
__decorate([
    Prop(),
    __metadata("design:type", typeof (_b = typeof Object !== "undefined" && Object) === "function" ? _b : Object)
], SnapshotGraph.prototype, "options", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Number)
], SnapshotGraph.prototype, "height", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Boolean)
], SnapshotGraph.prototype, "showLegend", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Boolean)
], SnapshotGraph.prototype, "displayLimits", void 0);
__decorate([
    Watch("showLimits"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean, Boolean]),
    __metadata("design:returntype", void 0)
], SnapshotGraph.prototype, "onShowLimitsChanged", null);
SnapshotGraph = __decorate([
    Component({
        components: {
            Bar
        },
        emits: ["displayLimitsChanged"],
    })
], SnapshotGraph);
export default SnapshotGraph;
